import { InputHTMLAttributes, Ref } from 'react';
import { twMerge } from 'tailwind-merge';

interface Props extends InputHTMLAttributes<HTMLInputElement> {
  wrapperClassName?: string;
  ref?: Ref<HTMLInputElement>;
}

/** Figma "input field": 40px, seeker-700 hairline, white focus ring, orange invalid. */
export const INPUT_CLASSES =
  'h-10 w-full rounded-lg border border-seeker-700 bg-transparent px-4 text-sm text-white outline-none transition-colors placeholder:text-seeker-400 hover:border-seeker-500 focus:border-white disabled:cursor-not-allowed disabled:text-seeker-400 disabled:hover:border-seeker-700 [&:user-invalid]:border-orange-400 [&:user-invalid]:hover:border-orange-300 [&:user-invalid]:focus:border-orange-400';

export const Input = (props: Props) => {
  const { className, wrapperClassName, ref, ...rest } = props;

  return (
    <div className={twMerge('relative', wrapperClassName)}>
      <input
        className={twMerge(INPUT_CLASSES, className)}
        ref={ref}
        style={{ backgroundColor: 'transparent' }}
        {...rest}
      />
    </div>
  );
};
